import { createAction, props } from "@ngrx/store";
import { Users } from "src/app/data/models";
import { UserPermissionViewModel } from "src/app/data/models/access-permission/accessPermissionViewModel";
import { RespondUser } from "src/app/data/models/respond/respond.model";

export const userLoggedIn = createAction('[Auth] User Logged In', props<{ user?: Users; respondUser?: RespondUser }>());
export const userLoggedOut = createAction('[Header] User Logged Out');

export const userPermissionsUpdated = createAction('User Permissions Updated', props<{ permissions: UserPermissionViewModel }>());
export const userPermissionsNotLoaded = createAction('User Permissions Not Loaded');

export const userEmulationStarted = createAction('[User List] Emulation Started', props<{ emulatedUser: Users }>());
export const userEmulationStopped = createAction('[Header] Emulation Stopped');

export const currentUserFeaturesUpdated = createAction('[User] Current User Features Updated', props<{ featureIds: number[] }>());